module.exports = __webpack_public_path__ + "static/media/just-because.bec462c1.jpg";